var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LFeatureGroup',_vm._l((_vm.measurements),function(location,i){return _c('HeatmapMarker',{key:i,attrs:{"location":location}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }